import { Icon } from '@iconify/react';
import { Link as RouterLink } from 'react-router-dom';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';

// material
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import {
  Box,
  Button,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Link,
} from '@material-ui/core';
// components
import { PATH_DASHBOARD } from '../../routes/paths';
import { MHidden } from '../../components/@material-extend';
// import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
// import LanguagePopover from './LanguagePopover';
// import ContactsPopover from './ContactsPopover';
// import NotificationsPopover from './NotificationsPopover';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;
const BANNER_HEIGHT = 30;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
  },
  top: BANNER_HEIGHT,
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

const BannerStyle = styled(AppBar)(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
  },
  boxShadow: 'none',
  textAlign: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.primary.lighter,
  height: BANNER_HEIGHT,
  color: theme.palette.primary.dark,
  display: 'flex',
  justifyContent: 'center',
}));

// ----------------------------------------------------------------------

type DashboardNavbarProps = {
  onOpenSidebar: VoidFunction;
};

export default function DashboardNavbar({ onOpenSidebar }: DashboardNavbarProps) {
  return (
    <>
      <Link href="https://baptlac.typeform.com/to/SmeySEtp">
        <BannerStyle>
          <Typography variant="caption">
            You are in demo mode, to activate your account click here
          </Typography>
        </BannerStyle>
      </Link>
      <RootStyle>
        <ToolbarStyle>
          <MHidden width="lgUp">
            <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
              <Icon icon={menu2Fill} />
            </IconButton>
          </MHidden>

          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="row" spacing={{ xs: 0.5, sm: 1.5 }}>
            {/* <LanguagePopover /> */}
            <Button variant="contained" to={PATH_DASHBOARD.transfer.deposit} component={RouterLink}>
              Deposit
            </Button>
            <Button variant="outlined" to={PATH_DASHBOARD.transfer.withdraw} component={RouterLink}>
              Withdraw
            </Button>
            {/* <NotificationsPopover /> */}
            {/* <ContactsPopover /> */}
            <AccountPopover />
          </Stack>
        </ToolbarStyle>
      </RootStyle>
    </>
  );
}
